import { AsyncState } from '../state/types';
import { AsyncStateStatus } from '../status/types';

function isStatus(actual: AsyncStateStatus, expected: AsyncStateStatus): boolean {
	return actual === expected;
}

function getStatusFromHybrid<T>(hybrid: AsyncStateStatus | AsyncState<T>): AsyncStateStatus {
	return (hybrid as AsyncState<T>)?.actionStatus ?? hybrid;
}

export function isErrored<T>(status: AsyncStateStatus | AsyncState<T>): boolean {
	return isStatus(getStatusFromHybrid(status), AsyncStateStatus.Errored);
}

export function isFailed<T>(status: AsyncStateStatus | AsyncState<T>): boolean {
	return isStatus(getStatusFromHybrid(status), AsyncStateStatus.Failed);
}

export function isIdle<T>(status: AsyncStateStatus | AsyncState<T>): boolean {
	return isStatus(getStatusFromHybrid(status), AsyncStateStatus.Idle);
}

export function isReceived<T>(status: AsyncStateStatus | AsyncState<T>): boolean {
	return isStatus(getStatusFromHybrid(status), AsyncStateStatus.Received);
}

export function isRequested<T>(status: AsyncStateStatus | AsyncState<T>): boolean {
	return isStatus(getStatusFromHybrid(status), AsyncStateStatus.Requested);
}
